var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading && !_vm.loaded
    ? _c("loading")
    : _vm.loadOnInit && !_vm.list.length
    ? _c("div")
    : _c(
        "div",
        { staticClass: "dropdown pb-3" },
        [
          _c("DropdownButton", {
            attrs: {
              id: _vm.itemId(_vm.selectedValue),
              label: `Select ${_vm.field}...`,
            },
            on: {
              remove: function ($event) {
                return _vm.$emit("chooseItem", {})
              },
              click: _vm.loadData,
            },
            scopedSlots: _vm._u([
              {
                key: "menu",
                fn: function () {
                  return [
                    _vm.allData
                      ? _c(
                          "ul",
                          {
                            staticClass: "dropdown-menu w-100",
                            staticStyle: {
                              "max-height": "400px",
                              "overflow-y": "scroll",
                            },
                            attrs: {
                              role: "menu",
                              "aria-labelledby": `submenu-${_vm.itemId(
                                _vm.selectedValue
                              )}`,
                            },
                          },
                          [
                            _vm._l(_vm.allData, function (item, index) {
                              return _c(
                                "li",
                                {
                                  key: `${_vm.itemId(item)}-${index}`,
                                  staticClass:
                                    "d-flex justify-content-between cursor-pointer p-3 border-bottom",
                                  attrs: { role: "presentation" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("chooseItem", item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 d-flex align-items-start",
                                    },
                                    [
                                      _c("h6", { staticClass: "m-0" }, [
                                        _vm._v(_vm._s(_vm.itemName(item))),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            _vm.loading
                              ? _c(
                                  "li",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between cursor-pointer p-2 border-bottom",
                                  },
                                  [_c("loading")],
                                  1
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      : _c("div", { staticClass: "text-muted" }, [
                          _vm._v("No locations found"),
                        ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }